// Service provider display names for consent messages
const PROVIDER_NAMES: Record<string, string> = {
  youtube: 'YouTube',
  spotify: 'Spotify',
  apple_music: 'Apple Music',
  vimeo: 'Vimeo',
  soundcloud: 'SoundCloud'
}

/**
 * Get the display name for a service provider
 * @param source - The service provider (e.g., 'youtube', 'spotify', 'apple_music')
 * @param override - Optional custom display name to use instead
 * @returns The display name to show in the consent message
 */
export const getProviderDisplayName = (source: string, override?: string): string => {
  if (override) return override
  return PROVIDER_NAMES[source] || source.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
}
